/**
 * Build the public pitch link URL for an investor slug.
 */
export function pitchLink(slug: string | null | undefined): string {
  return `${window.location.origin}/${slug ?? 'your-link'}`
}
